<template>
  <div class="phonebg" v-if="getuser">
    <!-- <div>{{wxuser}}</div> -->
    <div class="jiudian">
      <div class="title">{{userinfo.hotelname}}</div>
    </div>
    <div class="weixin">
      <div class="content">
        <div><img class="face" :src="wxuser.headimgurl" /></div>  
        <div class="name" v-html="wxuser.nickname"></div>
      </div>
    </div>
    <div class="weixin">
       <div class="title">绑定信息</div>
      <div class="content">
        <div>
          <img class="face" v-if="userinfo.photo !=null && userinfo.photo != ''" :src="image_base+userinfo.photo" />
          <img class="face" v-else src="../../assets/image/morentouxiang.jpg">
        </div>
        <div class="userinfo">
          <div><span class="fizeweight">账号：</span>{{userinfo.username}}</div>  
          <div>{{userinfo.cname}}<span class="fizeweight">：姓名</span></div>
        </div>
        <div class="userinfo">
           <div><span class="fizeweight">工号：</span>{{userinfo.employeeno}}</div>  
        <div>{{userinfo.situsname}}<span class="fizeweight">：站点</span></div>
        </div>
      </div>
      <div class="weixin">
        <div class="contentmima">
          <div>
             <span style="vertical-align: top;">密码：</span>
             <input class="txtmima" type="password" v-model="password" />
          </div>
          <div class="qrbd" @click="bangding">确认绑定</div>
        </div>
      </div>
    </div>

    <!-- <div v-if="false">
      <div>token:{{token}}</div>
      <div>wxuser:{{wxuser}}</div>
    </div>  -->
  </div>
</template>

<script>
import { postRequest,getRequest } from "@/api/api1.js";

export default {
  name: "welcome",
  data() {
    return {
      image_base:this.$store.state.api,
      password:null,
      token:null,
      getuser:true,
      userinfo:{},
      wxuser:{},
    };
  },
  created() {
     this.token =  this.$route.query.c;
    if(this.token == null || this.token == ''){
      this.getuser = false;
      return;
    }
    this.getCode();
  },
  mounted() {

  },
  methods: {
    bangding(){
       let param = {
        hotelid:this.userinfo.hotelid,
        username:this.userinfo.username,
        openid:this.wxuser.openid,
        nickname:this.wxuser.nickname,
        password:this.password,
        unionid:this.wxuser.unionid
      };
      let loadingInstance = this.$loading({ text: "用户绑定中..." });
      postRequest("/bindWeiXinUser",param).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.$router.push("/guanzhu?message=账号绑定成功");
        } else {
          alert(res.message)
        }
      });
    },
     getUserByToken() {
      let loadingInstance = this.$loading({ text: "正在加载绑定账号..." });
      getRequest("/getUserByToken?token="+this.token).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.userinfo = res.data;
        } else {
          this.getuser = false;
          alert(res.message)
        }
      });
    },  



    getCode() {
      let loadingInstance = this.$loading({ text: "数据加载中..." });
      // 非静默授权，第一次有弹框
      const code = this.getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      const local = window.location.href;
      const APPID = "wxe85988fe337541a9"; // 企业微信
      if (code == null || code == "") {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      } else {
        this.getOpenId(code); //把code传给后台获取用户信息
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    getOpenId(code) {
      let loadingInstance = this.$loading({ text: "正在加载用户..." });
      let param = {
        code:code
      };
      postRequest("/getwxuser",param).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.wxuser = res.data;
          //获取酒店用户信息
          this.getUserByToken();
        } else {
          this.getuser = false;
          alert(res.message)
        }

      });
    },  
  }
};
</script>

<style scoped>
.fizeweight{
  font-weight: bold;
}
.phonebg{
  width: 100%;
  height: 100%;
      overflow-y: auto;
  background:linear-gradient(0deg, #D6EBFF 0%, #E9F4FF 48%, #D6EBFF 100%);
/* background: linear-gradient(180deg, #D6EBFF, #E9F4FF 48%, #D6EBFF); */
}
.jiudian{
 box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
.title{
  text-align:center;
  font-weight: bold;
  font-size: 1.2rem;
  height: 3rem;
  line-height: 3rem;
}
.contentmima{
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding:5%;
  color: #575f6b;
  font-size: 1rem;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  
  text-align:center;
}
.content{
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding:5%;
  color: #575f6b;
  font-size: 1rem;
   box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  text-align:center;
}


.weixin,.yonghu{
  margin-top:1rem;
}
.name{
  font-weight: bold;
  font-size: 1.2rem;
}
.userinfo{
  display: flex;
    justify-content: space-between;
}
.face{
  width:4rem;
  border-radius: 100%;
}
.txtmima{
  width: 80%;
  line-height: 2rem;
  height: 2rem;
    font-size:2rem;
}
.qrbd{
  width:40%;
  color: #4bb0ff;
  text-align:center;
  margin-left: 30%;
  margin-top: 1rem;
  border-radius: .2em;
  box-shadow: 5px 5px 20px #a2b3dc, -5px -5px 20px #ffffff;
}
.cxsm{
    width: 100%;
    text-align: center;
    color: red;
    font-size: 1.6rem;
    padding-top: 3rem;
}

</style>